module.exports = __webpack_public_path__ + "static/media/4.35cf17d5.jpg";